<template>
  <div class="data-detail">
    <pageTitle :pageTitle="title">
      <div slot="content" v-if="moduleKey == 'cash_red_packet'">{{ $t('lang.k_189001') }}</div>
      <div slot="content" v-if="moduleKey == 'chat' && $route.query.wType == 6">
        {{ $t('lang.k_189002') }}
        <br />
        {{ $t('lang.k_189003') }}
      </div>
      <div slot="content" v-if="moduleKey == 'chat' && $route.query.wType != 6">
        {{ $t('lang.k_189004') }}
        <br />
        {{ $t('lang.k_189005') }}
      </div>
      <div slot="content" v-if="moduleKey == 'follow_user'">{{ $t('lang.k_189006') }}</div>
      <div slot="content" v-if="moduleKey == 'exam'">
        {{ $t('lang.k_189007') }}
        <br />
        {{ $t('lang.k_189008') }}
        <br />
        {{ $t('lang.k_189009') }}
        <br />
        {{ $t('lang.k_189010') }}
        <br />
        {{ $t('lang.k_189011') }}
      </div>
      <div slot="content" v-if="moduleKey == 'invite'">
        <p>{{ $t('lang.k_189012') }}</p>
        <p>{{ $t('lang.k_189013') }}</p>
        <p>{{ $t('lang.k_189014') }}</p>
      </div>
    </pageTitle>
    <div class="operaBox">
      <div class="searchBox">
        <!-- <vh-input
        :placeholder="placeholder"
        v-if="title=='邀请人数'"
        style="margin-right: 20px;"
        v-model="searchText">
        <i
          class="vh-icon-search vh-input__icon"
          slot="suffix">
        </i>
      </vh-input> -->
        <vh-date-picker
          v-model="searchTime"
          value-format="yyyy-MM-dd"
          type="daterange"
          round
          @change="changeDate"
          prefix-icon="iconfont-v3 saasicon_date"
          :range-separator="$t('lang.k_189015')"
          :start-placeholder="$t('lang.k_189016')"
          :end-placeholder="$t('lang.k_189017')"
          :picker-options="pickerOptions"
          style="width: 240px; margin-right: 20px"
          v-if="['chat', 'qa', 'follow_user', 'file_download', 'sign_in'].includes(moduleKey)"
        />
        <vh-button
          size="medium"
          round
          plain
          v-if="moduleKey === 'chat' || moduleKey === 'qa' || moduleKey === 'sign_in'"
          :disabled="!isSeletedCheckout"
          @click="deleteAll(null)"
        >
          {{ $t('lang.k_189018') }}
        </vh-button>
        <vh-button size="medium" round plain v-if="moduleKey === 'chat'" @click="clearAll()">
          {{ $t('lang.k_189019') }}
        </vh-button>
      </div>
      <span class="search-export">
        <vh-input
          v-model="searchText"
          round
          :placeholder="placeholder"
          v-if="moduleKey == 'chat' || moduleKey == 'invite' || moduleKey == 'file_download'"
          style="margin-right: 20px"
          @keyup.enter.native="searchKeyword"
          @clear="searchKeyword"
          @blur="searchKeyword"
          clearable
        >
          <i
            slot="suffix"
            class="vh-icon-search vh-input__icon"
            @click="searchKeyword"
            style="cursor: pointer; line-height: 36px"
          ></i>
        </vh-input>
        <vh-button round plain size="medium" @click="exportData" v-if="title != 'chat' && totalNum">
          {{ $t('lang.k_189020') }}
        </vh-button>
        <vh-dropdown
          v-if="$route.query.wType != 6 && moduleKey == 'chat'"
          @command="exportData"
          trigger="click"
        >
          <vh-button type="primary" round size="medium" class="create_but_padding">
            &nbsp; {{ $t('lang.k_189020') }} &nbsp;
          </vh-button>
          <vh-dropdown-menu slot="dropdown" class="dropdown_width">
            <vh-dropdown-item command="1" v-preventReClick size="medium">
              {{ $t('lang.k_189021') }}
            </vh-dropdown-item>
            <vh-dropdown-item command="2" v-preventReClick>
              {{ $t('lang.k_189022') }}
            </vh-dropdown-item>
          </vh-dropdown-menu>
        </vh-dropdown>
        <vh-dropdown
          v-if="moduleKey == 'sign_in' && totalNum"
          @command="exportSignDetail"
          trigger="click"
        >
          <vh-button type="primary" round size="medium" class="create_but_padding">
            &nbsp; {{ $t('lang.k_189023') }} &nbsp;
          </vh-button>
          <vh-dropdown-menu slot="dropdown" class="dropdown_width">
            <vh-dropdown-item command="1" v-preventReClick size="medium">
              {{ $t('lang.k_189024') }}
            </vh-dropdown-item>
            <vh-dropdown-item command="2" v-preventReClick>
              {{ $t('lang.k_189025') }}
            </vh-dropdown-item>
          </vh-dropdown-menu>
        </vh-dropdown>
        <vh-button
          round
          size="medium"
          @click="exportData"
          v-if="$route.query.wType == 6 && totalNum && moduleKey == 'chat'"
        >
          {{ $t('lang.k_189026') }}
        </vh-button>
        <vh-button
          round
          size="medium"
          @click="getGroupRound"
          v-if="$route.query.wType == 6 && moduleKey == 'chat'"
        >
          {{ $t('lang.k_189027') }}
        </vh-button>
      </span>
    </div>
    <div class="interact-detail" v-show="totalNum">
      <div class="interact-invite-totel" v-if="moduleKey == 'invite'">
        <i18n path="lang.k_189028" tag="div">
          <template>
            <span class="color_26">{{ inviteTotal }}</span>
          </template>
        </i18n>
      </div>
      <table-list
        :pageLimit="pageInfo.limit"
        scene="docDownload"
        ref="tableList"
        :manageTableData="tableList"
        :tabelColumnLabel="tabelColumn"
        :tableRowBtnFun="tableRowBtnFun"
        :isCheckout="isCheckout"
        :totalNum="totalNum"
        :rowKey="rowKey"
        :width="120"
        fixedBtn="right"
        @changeTableCheckbox="changeTableCheckbox"
        @onHandleBtnClick="onHandleBtnClick"
        @getTableList="getTableList"
      ></table-list>
    </div>
    <div class="no-live" v-show="!totalNum">
      <noData :nullType="nullText" :text="text"></noData>
    </div>
    <!-- 导出分组数据 - 选择场次面板  -->
    <VhallDialog
      :title="$t('lang.k_189030')"
      v-if="groupRoundVisible"
      :visible.sync="groupRoundVisible"
      width="410px"
    >
      <vh-form @submit.native.prevent label-width="64px">
        <vh-form-item class="no-border" :label="$t('lang.k_189031')">
          <vh-select
            :placeholder="$t('lang.k_189032')"
            round
            v-model="groupRound"
            style="width: 100%"
          >
            <vh-option
              v-for="item in groupRoundList"
              :key="'gr_' + item.id"
              :label="
                dayjs(item.start_time).format('YYYY-MM-DD HH:mm') +
                $t('lang.k_189033') +
                dayjs(item.end_time).format('YYYY-MM-DD HH:mm')
              "
              :value="item.id"
            ></vh-option>
          </vh-select>
        </vh-form-item>
      </vh-form>
      <div slot="footer" class="dialog-footer">
        <vh-button type="info" @click="closeGroupRoundDialog" plain round size="medium">
          {{ $t('lang.k_189034') }}
        </vh-button>
        <vh-button type="primary" @click="exportGroupByRound" round size="medium">
          {{ $t('lang.k_189035') }}
        </vh-button>
      </div>
    </VhallDialog>
    <vh-dialog
      :visible.sync="qaLikedialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :dialogCenter="true"
      width="800px"
      :title="$t('lang.k_189036')"
      custom-class="std-dialog std-dialog--medium"
    >
      <qaLikeList ref="qaLikeList"></qaLikeList>
    </vh-dialog>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle';
  import { textToEmoji } from './js/emoji';
  import noData from '@/views/PlatformModule/Error/nullPage';
  import { sessionOrLocal, embedRoomId, isEmbed, escapeHtml, safeJsonParse } from '@/utils/utils';
  import examServer from '@/utils/examServer';
  import { roundRate } from '@/utils/utils';
  import qaLikeList from './components/qaLikeList.vue';
  import useInviteRankChoice from '@/components/MessageBox/useInviteRankChoice.js';
  import to from 'await-to-js';

  export default {
    components: {
      PageTitle,
      noData,
      qaLikeList
    },
    data() {
      return {
        qaLikedialogVisible: false,
        qaLikeList: [],
        nullText: 'nullData',
        isSearch: false, //是否是搜索
        text: this.$t('lang.k_189037'),
        isCheckout: false,
        isSeletedCheckout: false,
        placeholder: '',
        title: '',
        moduleKey: '',
        webinarId: '',
        num: 0,
        roomId: '',
        userId: JSON.parse(sessionOrLocal.get('userId')),
        searchTime: null,
        searchText: '',
        params: {},
        seleteAllOptionList: [],
        seleteAnwerList: [], //答案
        seleteQuestionList: [], //问题
        selectSignInList: [], // 签到
        totalNum: 0,
        inviteTotal: 0, // 邀请总人数
        pageInfo: {
          pos: 0,
          pageNum: 1,
          limit: 10
        },
        pickerOptions: {
          // disabledDate是一个函数,参数是当前选中的日期值,这个函数需要返回一个Boolean值,
          disabledDate: time => {
            return this.dealDisabledData(time);
          }
        },
        tableList: [],
        groupRoundList: [], // 是否选择分组导出
        groupRoundVisible: false, // 是否展示选择分组导出 - 选择场次弹框
        groupRound: null,
        tabelColumn: [],
        // 邀请人数
        inviteColumn: [
          {
            label: this.$t('lang.k_189038'),
            key: 'rank_no',
            width: 90
          },
          {
            label: this.$t('lang.k_189039'), // 20250904-产品需求改成用户名实际上是昵称
            key: 'nick_name',
            width: 140
          },
          {
            label: this.$t('lang.k_189040'), // 20250904-产品需求改成用户名实际上是昵称
            key: 'nickname_updated',
            width: 180
          },
          {
            label: this.$t('lang.k_189041'),
            key: 'phone',
            width: 120
          },
          {
            label: this.$t('lang.k_189042'),
            key: 'num',
            width: 120
          },
          {
            label: this.$t('lang.k_189043'),
            key: 'watch_duration',
            width: 120
          },
          {
            label: this.$t('lang.k_189044'),
            key: 'live_watch_duration',
            width: 120
          },
          {
            label: this.$t('lang.k_189045'),
            key: 'vod_watch_duration',
            width: 120
          },
          {
            label: this.$t('lang.k_189046'),
            key: 'client',
            minWidth: 120
          },
          {
            label: this.$t('lang.k_189047'),
            key: 'location',
            minWidth: 120
          }
        ],

        // 聊天
        chatColumn: [
          {
            label: this.$t('lang.k_189048'),
            key: 'nickname',
            width: 100
          },
          {
            label: this.$t('lang.k_189049'),
            key: 'name',
            width: 100
          },
          {
            label: this.$t('lang.k_189050'),
            key: 'member_level',
            width: 60
          },
          {
            label: this.$t('lang.k_189051'),
            key: 'date_time',
            width: 180
          },
          {
            label: this.$t('lang.k_189052'),
            key: 'imgOrText'
          },
          {
            label: this.$t('lang.k_189053'),
            key: 'accept_name',
            width: 200
          }
        ],

        // 问答
        questColumn: [
          {
            label: this.$t('lang.k_189054'),
            key: 'name',
            width: 100
          },
          {
            label: this.$t('lang.k_189055'),
            key: 'imgOrText'
          },
          {
            label: this.$t('lang.k_189056'),
            key: 'like_count'
          },
          {
            label: this.$t('lang.k_189051'),
            key: 'created_at',
            width: 200
          },
          {
            label: this.$t('lang.k_189057'),
            key: 'is_open',
            width: 100
          },
          {
            label: this.$t('lang.k_189058'),
            key: 'statusText',
            width: 150
          }
          // {
          //   label: '审核状态',
          //   key: 'auditText',
          //   width: 150
          // }
        ],
        // 问卷
        questnaireColumn: [
          {
            label: this.$t('lang.k_189059'),
            key: 'survey_id'
          },
          {
            label: this.$t('lang.k_189060'),
            key: 'send_time'
          },
          {
            label: this.$t('lang.k_189061'),
            key: 'subject'
          },
          {
            label: this.$t('lang.k_189062'),
            key: 'filled_number'
          }
        ],

        // 签到
        signColumn: [
          {
            label: this.$t('lang.k_189059'),
            key: 'index'
          },
          {
            label: this.$t('lang.k_189063'),
            key: 'created_at'
          },
          {
            label: this.$t('lang.k_189064'),
            key: 'count'
          }
        ],

        // 抽奖
        drawColumn: [
          {
            label: this.$t('lang.k_189059'),
            key: 'index'
          },
          {
            label: this.$t('lang.k_189065'),
            key: 'title'
          },
          {
            label: this.$t('lang.k_189066'),
            key: 'create_time'
          },
          {
            label: this.$t('lang.k_189067'),
            key: 'lottery'
          },
          {
            label: this.$t('lang.k_189068'),
            key: 'num'
          }
        ],

        // 现金红包
        packetColumn: [
          {
            label: this.$t('lang.k_189059'),
            key: 'index',
            width: 80
          },
          {
            label: this.$t('lang.k_189069'),
            key: 'created_at'
          },
          {
            label: this.$t('lang.k_189070'),
            key: 'method'
          },
          {
            label: this.$t('lang.k_189071'),
            key: 'money'
          },
          {
            label: this.$t('lang.k_189072'),
            key: 'num',
            width: 120
          },
          {
            label: this.$t('lang.k_189073'),
            key: 'typeStr'
          }
        ],

        // 口令红包
        packetCodeColumn: [
          {
            label: this.$t('lang.k_189059'),
            key: 'index',
            width: 80
          },
          {
            label: this.$t('lang.k_189069'),
            key: 'created_at'
          },
          {
            label: this.$t('lang.k_189072'),
            key: 'num',
            width: 120
          },
          {
            label: this.$t('lang.k_189074'),
            key: 'get_user_count',
            width: 120
          }
        ],

        // 关注用户
        followersColumn: [
          {
            label: this.$t('lang.k_189075'),
            key: 'wechat_info'
          },
          {
            label: 'OpenID',
            key: 'open_id',
            width: 120
          },
          {
            label: this.$t('lang.k_189041'),
            key: 'phone',
            width: 120
          },
          {
            label: this.$t('lang.k_189076'),
            key: 'created_at',
            width: 120
          },
          {
            label: this.$t('lang.k_189043'),
            key: 'timer',
            width: 120
          }
        ],

        // 快问快答
        examColumn: [
          {
            label: this.$t('lang.k_189077'),
            key: 'push_time',
            width: 180
          },
          {
            label: this.$t('lang.k_189078'),
            key: 'title'
          },
          {
            label: this.$t('lang.k_189079'),
            key: 'un_answered_num',
            width: 105
          },
          {
            label: this.$t('lang.k_189080'),
            key: 'answer_num',
            width: 95
          },
          {
            label: this.$t('lang.k_189081'),
            key: 'full_score_rate',
            width: 100
          },
          {
            label: this.$t('lang.k_189082'),
            key: 'avg_score',
            width: 95
          }
        ],

        // 文件下载
        downloadsColumn: [
          {
            label: this.$t('lang.k_189083'),
            key: 'file_name',
            customTooltip: true
          },
          {
            label: this.$t('lang.k_189084'),
            key: 'file_size',
            width: 120
          },
          {
            label: this.$t('lang.k_189085'),
            key: 'file_ext',
            width: 120
          },
          {
            label: this.$t('lang.k_189086'),
            key: 'pv',
            width: 120
          },
          {
            label: this.$t('lang.k_189087'),
            key: 'uv',
            width: 120
          },
          {
            label: this.$t('lang.k_189088'),
            key: 'rate',
            width: 120
          }
        ],

        tableRowBtnFun: [],
        inviteBtnFun: [
          {
            name: this.$t('lang.k_189023'),
            methodName: 'reportDetail'
          }
        ],

        inviteBtnFun_watch: [
          {
            name: this.$t('lang.k_189089'),
            methodName: 'watchInfo'
          },
          {
            name: this.$t('lang.k_189090'),
            methodName: 'exportRowInviteDetail'
          }
        ],

        chatBtnFun: [
          {
            name: this.$t('lang.k_189091'),
            methodName: 'chatDetele'
          }
        ],

        anwerBtnFun: [
          {
            name: this.$t('lang.k_189091'),
            methodName: 'anwerDetele'
          }
        ],

        questnaireBtnFun: [
          {
            name: this.$t('lang.k_189092'),
            methodName: 'lookDetail',
            path: '/live/lookSingleQuestion'
          }
        ],

        examBtnFun: [
          {
            name: this.$t('lang.k_189089'),
            methodName: 'lookExamDetail',
            path: '/live/lookSingleExam'
          }
        ],

        downloadsFun: [
          {
            name: this.$t('lang.k_189023'),
            methodName: 'reportDetail'
          }
        ],

        rowKey: undefined
      };
    },
    async created() {
      // await this.getCustomRoleName()
    },
    mounted() {
      this.title = this.$route.query.title;
      this.moduleKey = this.$route.query.mkey;
      this.webinarId = this.$route.query.id;
      this.roomId = this.$route.query.roomId;
      this.changeColumn(this.moduleKey);
    },
    methods: {
      viewQALikeList(that, el) {
        that.qaLikedialogVisible = true;
        console.error(this.downloadsFun);
        that.$nextTick(() => {
          that.$refs.qaLikeList.load({
            webinar_id: that.$route.query.id,
            question_ids: el.rows.id
          });
        });
      },
      getCustomRoleName() {
        this.$fetch('getCustomRoleName', { webinar_id: this.$route.query.id }).then(res => {
          if (res.code == 200) {
            console.log('7777777', res.data, res.data.host_name);
            sessionStorage.setItem('getCustomHostRoleName', res.data.host_name);
            sessionStorage.setItem('getCustomAssistantRoleName', res.data.assistant_name);
            sessionStorage.setItem('getCustomGuestRoleName', res.data.guest_name);
          }
        });
      },
      dealDisabledData(time) {
        return time.getTime() > Date.now(); //设置选择今天以及今天以前的日期
      },
      emojiToText(content) {
        if (!content) {
          return '';
        }
        console.warn(content, 'content');
        return textToEmoji(content)
          .map(c => {
            return c.msgType == 'text'
              ? c.msgCont
              : `<img width="24" src="${c.msgImage}" border="0" />`;
          })
          .join(' ');
      },
      changeColumn(moduleKey) {
        let pageInfo = this.$refs.tableList.pageInfo;
        this.params = {};
        switch (moduleKey) {
          case 'invite':
            this.isCheckout = false;
            this.tabelColumn = this.inviteColumn;
            this.tableRowBtnFun = this.inviteBtnFun_watch;
            this.placeholder = this.$t('lang.k_189093'); // 20250904-产品需求改成用户名实际上是昵称
            this.inviteInfo(pageInfo);
            break;
          case 'sign_in':
            this.isCheckout = true;
            this.tabelColumn = this.signColumn;
            this.tableRowBtnFun = this.inviteBtnFun;
            this.signInfoList(pageInfo);
            break;
          case 'chat':
            this.rowKey = 'msg_id';
            this.isCheckout = true;
            this.placeholder = this.$t('lang.k_189094');
            this.tabelColumn = this.chatColumn;
            this.tableRowBtnFun = this.chatBtnFun;
            this.chatInfo(pageInfo);
            break;
          case 'qa':
            this.isCheckout = true;
            this.tabelColumn = this.questColumn;
            this.tableRowBtnFun = this.anwerBtnFun;
            this.getRecordList(pageInfo);
            break;
          case 'lottery':
            this.isCheckout = false;
            this.tabelColumn = this.drawColumn;
            this.tableRowBtnFun = this.inviteBtnFun;
            this.prizeList();
            break;
          case 'question':
            this.isCheckout = false;
            this.tabelColumn = this.questnaireColumn;
            this.tableRowBtnFun = this.questnaireBtnFun;
            this.getQuestionInfo();
            break;
          case 'cash_red_packet':
            this.tabelColumn = this.packetColumn;
            this.isCheckout = false;
            this.tableRowBtnFun = this.inviteBtnFun;
            this.getRedpacketList();
            break;
          case 'code_red_packet':
            this.tabelColumn = this.packetCodeColumn;
            this.isCheckout = false;
            this.tableRowBtnFun = this.inviteBtnFun;
            this.getCodeRedpacketList();
            break;
          case 'follow_user':
            this.isCheckout = false;
            this.tabelColumn = this.followersColumn;
            this.placeholder = this.$t('lang.k_189095');
            this.text = this.$t('lang.k_189096');
            this.getFollowersList();
            break;
          case 'exam':
            this.isCheckout = false;
            this.tabelColumn = this.examColumn;
            this.tableRowBtnFun = this.examBtnFun;
            this.getExamInfo();
            break;
          case 'file_download':
            this.placeholder = this.$t('lang.k_189097');
            this.isCheckout = false;
            this.tabelColumn = this.downloadsColumn;
            this.tableRowBtnFun = this.downloadsFun;
            this.getFilesDownloadsList();
            break;
          default:
            break;
        }
      },
      changeDate() {
        switch (this.moduleKey) {
          case 'qa':
            this.getRecordList(this.pageInfo);
            break;
          case 'file_download':
            this.getFilesDownloadsList(true);
            break;
          case 'sign_in':
            this.signInfoList(this.pageInfo);
            break;
          default:
            this.$refs.tableList.clearSelect();
            this.chatInfo(this.pageInfo);
        }
      },
      onHandleBtnClick(val) {
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      searchKeyword() {
        switch (this.moduleKey) {
          case 'invite':
            this.pageInfo.pos = 0;
            this.$refs.tableList.pageInfo.pos = 0;
            this.$refs.tableList.pageInfo.pageNum = 1;
            this.inviteInfo(this.pageInfo);
            break;
          case 'chat':
            this.pageInfo.pos = 0;
            this.pageInfo.pageNum = 1;
            this.$refs.tableList.clearSelect();
            this.chatInfo(this.pageInfo);
            break;
          case 'file_download':
            this.getFilesDownloadsList(true);
        }
      },
      // 邀请人数
      inviteInfo(pageInfo) {
        // let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        let params = {
          source_id: +this.webinarId,
          source_type: 1,
          pos: pageInfo.pos,
          limit: pageInfo.limit,
          nickname: this.searchText
        };
        this.$fetch('getInviteListInfo', this.$params(params), {
          'Content-Type': 'application/json'
        }).then(res => {
          this.tableList = res.data?.list || [];
          this.tableList.map((item, index) => {
            item.index = index + 1;
          });
          this.inviteTotal = res.data?.count || 0;
          this.totalNum = res.data?.total || 0;
          if (this.searchText) {
            this.nullText = 'search';
            this.text = '';
            this.isSearch = true;
          } else {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189098');
            this.isSearch = false;
          }
        });
      },
      // 聊天
      async chatInfo(pageInfo) {
        const page = this.$refs.tableList.pageInfo;
        page.pageNum = pageInfo.pageNum;
        page.pos = pageInfo.pos;
        await this.getCustomRoleName();
        // let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        let params = {
          room_id: this.roomId,
          keyword: this.searchText,
          ...pageInfo
        };
        if (this.searchTime) {
          this.$refs.tableList.clearSelect();
          params.start_time = this.searchTime[0] + ' 00:00:00';
          params.end_time = this.searchTime[1] + ' 23:59:59';
          this.params = {
            room_id: this.roomId,
            keyword: this.searchText,
            start_time: this.searchTime[0] + ' 00:00:00',
            end_time: this.searchTime[1] + ' 23:59:59'
          };
        } else {
          this.params = {
            room_id: this.roomId,
            keyword: this.searchText
          };
        }
        // setTimeout(() => {
        // let obj = Object.assign({}, pageInfo, params);
        this.$fetch('getChatListInfo', params).then(res => {
          this.tableList = res.data.list;
          this.tableList.map(item => {
            const hostName = sessionStorage.getItem('getCustomHostRoleName', res.data.host_name);
            const assistantName = sessionStorage.getItem(
              'getCustomAssistantRoleName',
              res.data.assistant_name
            );
            const guestName = sessionStorage.getItem('getCustomGuestRoleName', res.data.guest_name);
            item.name =
              item.role_name == 1
                ? hostName
                  ? hostName
                  : this.$t('lang.k_189099')
                : item.role_name == 2
                ? item.context.extra_identity == 1 || item.context.is_chatbot == 1
                  ? this.$t('lang.k_189100')
                  : item.context.extra_identity == 2
                  ? this.$t('lang.k_189101')
                  : this.$t('lang.k_189102')
                : item.role_name == 3
                ? assistantName
                  ? assistantName
                  : this.$t('lang.k_189103')
                : guestName
                ? guestName
                : this.$t('lang.k_189104');

            item.data.barrage_txt = escapeHtml(item.data.barrage_txt);
            item.data.text_content = escapeHtml(item.data.text_content);
            if (item.data.barrage_txt && /\[|\]/g.test(item.data.barrage_txt)) {
              item.data.barrage_txt = this.emojiToText(item.data.barrage_txt) || '';
            }
            if (item.data.text_content && /\[|\]/g.test(item.data.text_content)) {
              item.data.barrage_txt = this.emojiToText(item.data.text_content);
            } else {
              item.data.barrage_txt = item.data.text_content || '';
            }
            if (item.data.image_urls && item.data.image_urls.length != 0) {
              item.chatImg = this.chartsImgs(item.data.image_urls);
            } else {
              item.chatImg = '';
            }
            if (new Date(item.date_time).getTime() < 1698249600) {
              // 历史兼容性数据处理，只处理 2023-10-26 00:00:00 之前的数据
              item.data.barrage_txt = item.data.barrage_txt.replace(/\*\*\*/g, '@');
            }
            item.imgOrText = item.data.barrage_txt + item.chatImg;
          });
          this.totalNum = res.data.total;
          if (this.searchTime || this.searchText) {
            this.nullText = 'search';
            this.text = '';
            this.isSearch = true;
          } else {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189105');
            this.isSearch = false;
          }
        });
        // }, 500)
      },
      chartsImgs(list) {
        let arr = '';
        if (list.length) {
          list
            .map((item, index) => {
              arr += `<img style="display:inline-block;width: 40px;object-fit: scale-down;height: 100%;" src="${item}" border="0" />`;
            })
            .join(' ');
        }
        return arr;
      },
      //删除聊天（二次确认）
      chatConfirmSure(id, index) {
        this.$vhConfirm(this.$t('lang.k_189106'), this.$t('lang.k_189107'), {
          confirmButtonText: this.$t('lang.k_189035'),
          cancelButtonText: this.$t('lang.k_189034'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            let obj = {
              msg_id: id,
              room_id: this.roomId
            };
            this.$fetch('deleteChatList', obj).then(res => {
              if (res.code == 200) {
                this.$vhall_paas_port({
                  k: index === 1 ? 100459 : 100460,
                  data: {
                    business_uid: this.userId,
                    user_id: '',
                    webinar_id: this.$route.params.str || this.$route.query.id,
                    refer: '',
                    s: '',
                    report_extra: {},
                    ref_url: '',
                    req_url: ''
                  }
                });
                this.$vhMessage({
                  message: `${this.$t('lang.k_189108')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                this.$refs.tableList.clearSelect();
                this.chatInfo(this.pageInfo);
              } else {
                this.$vhMessage({
                  message: `${this.$t('lang.k_189109')}`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              }
            });
          })
          .catch(() => {
            this.$vhMessage({
              message: `${this.$t('lang.k_189110')}`,
              showClose: true,
              // duration: 0,
              type: 'info',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 聊天删除
      chatDetele(that, { rows }) {
        that.chatConfirmSure(rows.msg_id, 2);
      },
      // 批量删除(问答和聊天)
      deleteAll(id) {
        if (this.moduleKey === 'chat') {
          if (this.seleteAllOptionList.length < 1) {
            this.$vhMessage({
              message: `${this.$t('lang.k_189111')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          } else {
            id = this.seleteAllOptionList.join(',');
            this.chatConfirmSure(id, 1);
          }
        } else if (this.moduleKey === 'sign_in') {
          if (this.selectSignInList.length < 1) {
            this.$vhMessage({
              message: this.$t('lang.k_189111'),
              showClose: true,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          } else {
            this.$vhConfirm(this.$t('lang.k_189112'), this.$t('lang.k_189107'), {
              confirmButtonText: this.$t('lang.k_189035'),
              cancelButtonText: this.$t('lang.k_189034'),
              customClass: 'zdy-message-box',
              lockScroll: false,
              roundButton: true,

              cancelButtonClass: 'zdy-confirm-cancel'
            }).then(() => {
              const params = {
                room_id: this.roomId,
                sign_ids: this.selectSignInList.join(',')
              };
              this.$fetch('delSignInList', this.$params(params)).then(res => {
                if (res.code == 200) {
                  this.$vhMessage({
                    message: `${this.$t('lang.k_189108')}`,
                    showClose: true,
                    // duration: 0,
                    type: 'success',
                    customClass: 'zdy-info-box'
                  });
                  this.selectSignInList = [];
                  this.signInfoList(this.pageInfo);
                } else {
                  this.$vhMessage({
                    message: res.msg,
                    showClose: true,
                    // duration: 0,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                }
              });
            });
          }
        } else {
          if (this.seleteAnwerList.length < 1 && this.seleteQuestionList.length < 1) {
            this.$vhMessage({
              message: `${this.$t('lang.k_189111')}`,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          } else {
            this.recordAllDelete();
          }
        }
      },

      //清空聊天
      clearAll() {
        this.$vhConfirm(this.$t('lang.k_189113'), this.$t('lang.k_189107'), {
          confirmButtonText: this.$t('lang.k_189035'),
          cancelButtonText: this.$t('lang.k_189034'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,
          //
          cancelButtonClass: 'zdy-confirm-cancel'
        }).then(() => {
          let obj = {
            room_id: this.roomId,
            clear: 1
          };
          this.$fetch('deleteChatList', obj).then(res => {
            if (res.code == 200) {
              this.$vhMessage({
                message: `${this.$t('lang.k_189108')}`,
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              this.$refs.tableList.clearSelect();
              this.chatInfo(this.pageInfo);
            } else {
              this.$vhMessage({
                message: `${this.$t('lang.k_189109')}`,
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            }
          });
        });
      },
      // 问答批量删除
      recordAllDelete() {
        this.$vhConfirm(this.$t('lang.k_189114'), this.$t('lang.k_189107'), {
          confirmButtonText: this.$t('lang.k_189035'),
          cancelButtonText: this.$t('lang.k_189034'),
          customClass: 'zdy-message-box',
          lockScroll: false,
          roundButton: true,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            let obj = {
              ques_ids: this.seleteQuestionList.join(','),
              answer_ids: this.seleteAnwerList.join(','),
              room_id: this.roomId
            };
            this.$fetch('deleteAllRecodrder', this.$params(obj)).then(res => {
              this.$vhall_paas_port({
                k: 100463,
                data: {
                  business_uid: this.userId,
                  user_id: '',
                  webinar_id: this.$route.params.str,
                  refer: '',
                  s: '',
                  report_extra: {},
                  ref_url: '',
                  req_url: ''
                }
              });
              this.$vhMessage({
                message: this.$t('lang.k_189108'),
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              this.getRecordList(this.pageInfo);
            });
          })
          .catch(() => {
            this.$vhMessage({
              message: `${this.$t('lang.k_189110')}`,
              showClose: true,
              // duration: 0,
              type: 'info',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 问答单个删除
      anwerDetele(that, { rows }) {
        that
          .$vhConfirm(that.$t('lang.k_189115'), that.$t('lang.k_189107'), {
            confirmButtonText: that.$t('lang.k_189035'),
            cancelButtonText: that.$t('lang.k_189034'),
            customClass: 'zdy-message-box',
            lockScroll: false,

            roundButton: true,
            cancelButtonClass: 'zdy-confirm-cancel'
          })
          .then(() => {
            let obj = {
              id: rows.id,
              type: rows.name === '问' ? 2 : 1,
              room_id: that.roomId
            };
            that.$fetch('deleteRecodrder', obj).then(res => {
              that.$vhall_paas_port({
                k: 100462,
                data: {
                  business_uid: that.userId,
                  user_id: '',
                  webinar_id: that.$route.params.str,
                  refer: '',
                  s: '',
                  report_extra: {},
                  ref_url: '',
                  req_url: ''
                }
              });
              that.$vhMessage.success(that.$t('lang.k_189108'));
              that.getRecordList(that.pageInfo);
            });
          })
          .catch(() => {
            that.$vhMessage({
              message: `${that.$t('lang.k_189110')}`,
              showClose: true,
              // duration: 0,
              type: 'info',
              customClass: 'zdy-info-box'
            });
          });
      },
      //签到
      signInfoList(pageInfo) {
        const page = this.$refs.tableList.pageInfo;
        page.pageNum = pageInfo.pageNum;
        page.pos = pageInfo.pos;
        let params = {
          room_id: this.roomId
        };
        if (this.searchTime) {
          params.start_time = this.searchTime[0] + ' 00:00:00';
          params.end_time = this.searchTime[1] + ' 23:59:59';
        }
        let obj = Object.assign({}, pageInfo, params);
        this.$fetch('getSignList', obj).then(res => {
          this.tableList = res.data.list;
          this.tableList.map((item, index) => {
            item.index = index + 1;
          });
          this.totalNum = res.data.total;
          if (!res.data.total) {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189116');
          }
        });
      },
      // 问卷
      getQuestionInfo() {
        let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        let params = {
          room_id: this.roomId,
          webinar_id: this.webinarId
        };
        let obj = Object.assign({}, pageInfo, params);
        this.$fetch('getSurveyUsageInfo', obj).then(res => {
          this.tableList = res.data.list;
          this.totalNum = res.data.total;
          if (!res.data.total) {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189117');
          }
        });
      },
      // 快问快答
      getExamInfo() {
        let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        let params = {
          source_type: 1,
          source_id: this.webinarId,
          pos: (pageInfo.pageNum - 1) * pageInfo.limit
        };
        let obj = Object.assign({}, pageInfo, params);
        examServer
          .getExamPushedList(obj)
          .then(res => {
            const list = res.data.list || [];
            list.map(item => {
              item.full_score_rate = roundRate(item.full_score_rate) + '%';
              item.avg_score = roundRate(item.avg_score);
            });
            this.tableList = list;
            this.totalNum = res.data.total || 0;
            if (!res.data.total) {
              this.nullText = 'nullData';
              this.text = this.$t('lang.k_189118');
            }
          })
          .catch(() => {
            this.tableList = [];
            this.totalNum = 0;
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189118');
          });
      },
      // 文件下载
      getFilesDownloadsList(search) {
        let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        if (search) {
          pageInfo.pageNum = 1;
        }
        let params = {
          webinar_id: this.webinarId,
          pos: (pageInfo.pageNum - 1) * pageInfo.limit
        };
        if (this.searchText) {
          params.file_name = this.searchText;
        }
        if (this.searchTime) {
          params.start_date = this.searchTime[0];
          params.end_date = this.searchTime[1];
        }
        let obj = Object.assign({}, pageInfo, params);
        this.$fetch('getFilesDownloadsList', obj)
          .then(res => {
            this.tableList = res.data.list;
            this.totalNum = res.data.total || 0;
            if (this.searchTime || this.searchText) {
              this.nullText = 'search';
              this.text = '';
              this.isSearch = true;
            } else {
              this.nullText = 'nullData';
              this.text = this.$t('lang.k_189119');
              this.isSearch = false;
            }
          })
          .catch(() => {
            this.tableList = [];
            this.totalNum = 0;
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189119');
          });
      },
      // 抽奖
      prizeList() {
        let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        let params = {
          webinar_id: this.webinarId
        };
        this.params = params;
        let obj = Object.assign({}, pageInfo, params);
        this.$fetch('getPrizeListInfo', obj).then(res => {
          this.tableList = res.data.list;
          this.tableList.map((item, index) => {
            item.index = index + 1;
            item.lottery = this.lotteryType(item.lottery_type);
          });
          this.totalNum = res.data.total;
          if (!res.data.total) {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189120');
          }
        });
      },
      lotteryType(type) {
        if (type == 1) {
          return this.$t('lang.k_189121');
        } else if (type == 2) {
          return this.$t('lang.k_189122');
        } else if (type == 3) {
          return this.$t('lang.k_189123');
        } else if (type == 8) {
          return this.$t('lang.k_189124');
        } else if (type == 21) {
          return this.$t('lang.k_189125');
        } else {
          return this.$t('lang.k_189121');
        }
      },
      // 回答
      async getRecordList(pageInfo) {
        await this.getCustomRoleName();
        // let pageInfo = this.$refs.tableList.pageInfo; //获取分页信息
        let params = {
          room_id: this.roomId
        };
        if (this.searchTime) {
          this.$refs.tableList.clearSelect();
          params.start_time = this.searchTime[0];
          params.end_time = this.searchTime[1];
        }
        this.tableList = [];
        let obj = Object.assign({}, pageInfo, params);
        this.params = params;
        this.$fetch('getRecodrderList', obj).then(res => {
          // this.params.start_time = res.data.start_time;
          // this.params.end_time = res.data.end_time;
          // this.tableList = res.data.list;
          // this.tableList.map(item => {
          //   item.statusText = item.status == 1 ? '不处理' : item.status == 2 ? '转给主持人 即语音回复' : item.status == 3 ? '文字回复' : '未处理';
          //   item.name = '问';
          //   if (item.answer.length) {
          //     item.answer[0].name = '答';
          //     item.answer[0].is_open = item.answer[0].is_open == 1 ? '公开' : '私密';
          //   }
          // })
          const hostName = sessionStorage.getItem('getCustomHostRoleName', res.data.host_name);
          const assistantName = sessionStorage.getItem(
            'getCustomAssistantRoleName',
            res.data.assistant_name
          );
          const guestName = sessionStorage.getItem('getCustomGuestRoleName', res.data.guest_name);
          let tableList = res.data.list;
          const statusMap = {
            0: this.$t('lang.k_189126'),
            1: this.$t('lang.k_189127'),
            2: this.$t('lang.k_189128'),
            3: this.$t('lang.k_189129'),
            4: '--',
            5: this.$t('lang.k_189130')
          };
          tableList.map((item, index) => {
            if (item.content && /\[|\]/g.test(item.content)) {
              item.content = this.emojiToText(item.content) || '';
            } else {
              item.content = item.content || '';
            }
            item.statusText = statusMap[item.status];

            item.auditText =
              item.audit_status == 0
                ? this.$t('lang.k_189131')
                : item.audit_status == 1
                ? this.$t('lang.k_189132')
                : this.$t('lang.k_189133');
            item.name = '问';
            item.imgOrText = this.$t('lang.k_189134', [item.nick_name, item.content]);
            this.tableList.push(item);
            if (item.answer.length) {
              item.answer.map(opt => {
                opt.is_open =
                  opt.is_open == 1 ? this.$t('lang.k_189135') : this.$t('lang.k_189057');
                opt.name = '答';
                opt.imgOrText = `${opt.nick_name} | ${
                  opt.role == 'host'
                    ? hostName
                      ? hostName
                      : opt.role_name
                    : opt.role == 'assistant'
                    ? assistantName
                      ? assistantName
                      : opt.role_name
                    : guestName
                    ? guestName
                    : opt.role_name
                } </br> ${opt.content}`;
                this.tableList.push(opt);
              });
            }
          });
          this.totalNum = res.data.total;
          if (this.searchTime) {
            this.nullText = 'search';
            this.text = '';
            this.isSearch = true;
          } else {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189136');
            this.isSearch = false;
          }
        });
      },
      // 问答删除
      handleDelete(item) {
        this.$vhConfirm(this.$t('lang.k_189137'), this.$t('lang.k_189107'), {
          confirmButtonText: this.$t('lang.k_189035'),
          cancelButtonText: this.$t('lang.k_189034'),
          customClass: 'zdy-message-box',
          lockScroll: false,

          roundButton: true,
          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            let obj = {
              id: item.id,
              type: item.name === '问' ? 2 : 1,
              room_id: this.roomId
            };
            this.$fetch('deleteRecodrder', obj).then(res => {
              this.$vhMessage({
                message: this.$t('lang.k_189108'),
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              this.getRecordList(this.pageInfo);
            });
          })
          .catch(() => {
            this.$vhMessage({
              message: `${this.$t('lang.k_189110')}`,
              showClose: true,
              // duration: 0,
              type: 'info',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 现金红包列表
      getRedpacketList() {
        let pageInfo = this.$refs.tableList.pageInfo;
        pageInfo.pos = pageInfo.pageNum;
        let formParams = {
          webinar_id: this.webinarId
        };
        let obj = Object.assign({}, pageInfo, formParams);
        this.$fetch('getRedpacketList', obj).then(res => {
          this.tableList = res.data.data;
          this.totalNum = res.data.total;
          if (!res.data.total) {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189138');
          }
          this.tableList.map((item, index) => {
            item.method =
              item.pay_channel == 1
                ? this.$t('lang.k_189139')
                : item.pay_channel == 2
                ? this.$t('lang.k_189140')
                : item.pay_channel == 3
                ? this.$t('lang.k_189141')
                : '-';
            item.typeStr = item.type === 1 ? this.$t('lang.k_189142') : this.$t('lang.k_189143');
            item.index = index + 1;
          });
        });
      },
      // 红包列表
      getCodeRedpacketList() {
        let pageInfo = this.$refs.tableList.pageInfo;
        pageInfo.pos = pageInfo.pageNum;
        let formParams = {
          webinar_id: this.webinarId
        };
        let obj = Object.assign({}, pageInfo, formParams);
        this.$fetch('getCodeRedpacketList', obj).then(res => {
          this.tableList = res.data.data;
          this.totalNum = res.data.total;
          if (!res.data.total) {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189138');
          } else {
            this.tableList.map((item, index) => {
              item.index = index + 1;
            });
          }
        });
      },
      // 关注用户列表
      getFollowersList() {
        let params = {
          room_id: this.roomId
        };
        if (this.searchTime) {
          this.$refs.tableList.clearSelect();
          params.start_time = this.searchTime[0];
          params.end_time = this.searchTime[1];
        }
        this.tableList = [];
        let obj = Object.assign({}, pageInfo, params);
        this.params = params;
        this.$fetch('getFollowersList', obj).then(res => {
          this.tableList = res.data.data;
          this.totalNum = res.data.total;
          if (!res.data.total) {
            this.nullText = 'nullData';
            this.text = this.$t('lang.k_189096');
          } else {
            this.tableList.map((item, index) => {
              item.index = index + 1;
            });
          }
        });
      },
      getTableList(params) {
        this.pageInfo.limit = params.limit;
        this.changeColumn(this.moduleKey);
      },
      // 导出明细
      reportDetail(that, { rows }) {
        if (that.moduleKey === 'cash_red_packet') {
          that.exportRedpacketDetailInfo(rows.id, rows.type);
        } else if (that.moduleKey === 'code_red_packet') {
          that.exportCodeRedpacketDetailInfo(rows.id);
        } else if (that.moduleKey === 'sign_in') {
          that.exportDetailSignInfo(rows.id);
        } else if (that.moduleKey === 'invite') {
          that.exportInviteDetailInfo(rows.invite_id);
        } else if (that.moduleKey === 'file_download') {
          that.exportFileDetailDownloads(rows.webinar_id, rows.file_id);
        } else {
          that.exportPrizeDetailInfo(rows);
        }
      },
      changeTableCheckbox(val) {
        console.log('val:', val);
        if (this.moduleKey === 'chat') {
          this.seleteAllOptionList = val.map(item => item.msg_id);
          this.isSeletedCheckout = this.seleteAllOptionList.length > 0 ? true : false;
        } else if (this.moduleKey === 'sign_in') {
          this.selectSignInList = val.map(el => el.id);
          this.isSeletedCheckout = this.selectSignInList.length > 0 ? true : false;
        } else {
          this.seleteAnwerList = val.filter(item => item.name == '答').map(item => item.id);
          this.seleteQuestionList = val.filter(item => item.name == '问').map(item => item.id);
          if (this.seleteAnwerList.length > 0 || this.seleteQuestionList.length > 0) {
            this.isSeletedCheckout = true;
          } else {
            this.isSeletedCheckout = false;
          }
        }
      },
      async exportData(type) {
        switch (this.moduleKey) {
          case 'invite':
            // 弹窗选择导出字段
            const [error, formData] = await to(
              useInviteRankChoice(this.$createElement, {
                title: this.$t('lang.k_189020'),
                messageOptions: {
                  confirmButtonText: this.$t('lang.k_189090'),
                  customClass: 'vh-message-box--inviterank'
                }
              })
            );
            if (error || !formData || !formData.export_fields) return;
            // 拿到 fromData 继续处理业务
            this.exportInviteInfo(formData.export_fields);
            break;
          case 'sign_in':
            this.exportSignInfo();
            break;
          case 'chat':
            this.exportChatInfo(type); // 基本聊天导出，or分组直播中 - 导出聊天 - 主直播间数据
            break;
          case 'qa':
            this.exportRecordInfo();
            break;
          case 'lottery':
            this.exportPrizeInfo();
            break;
          case 'question':
            this.exportQuestionInfo();
            break;
          case 'cash_red_packet':
            this.exportRedpacketInfo();
            break;
          case 'code_red_packet':
            this.exportCodeRedpacketInfo();
            break;
          case 'follow_user':
            this.exportFollowersInfo();
            break;
          case 'exam':
            this.exportExamInfo();
            break;
          case 'file_download':
            this.exportFileDownloads();
            break;
          default:
            break;
        }
      },
      exportSignDetail(type) {
        const params = {
          room_id: this.roomId
        };
        if (type == 1 && this.searchTime) {
          params.start_time = this.searchTime[0] + ' 00:00:00';
          params.end_time = this.searchTime[1] + ' 23:59:59';
        }
        this.$fetch('batchExportSignDetail', this.$params(params)).then(res => {
          if (res.code == 200) {
            const endToast =
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144');
            this.$vhMessage({
              message: this.$t('lang.k_189145', [endToast]),
              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          } else {
            this.$vhMessage({
              message: res.msg,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          }
        });
      },
      // 获取可选场次
      async getGroupRound() {
        try {
          let roundResult = await this.$fetch(
            'getWebinarSwitchList',
            this.$params({ webinar_id: this.webinarId, ...this.params })
          );
          if (roundResult && roundResult.code == 200) {
            this.groupRoundList = roundResult.data.switch_list || [];
            if (this.groupRoundList.length > 0) {
              this.groupRoundVisible = true;
            } else {
              this.groupRoundVisible = false;
              this.$vhMessage({
                message: this.$t('lang.k_189146'),
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            }
          }
        } catch (e) {
          this.groupRoundVisible = false;
          this.$vhMessage({
            message: `${this.$t('lang.k_189146')}`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
      },
      closeGroupRoundDialog() {
        this.groupRoundVisible = false;
      },
      exportGroupByRound() {
        if (this.groupRound) {
          const vo = this.groupRoundList.filter(item => item.id == this.groupRound);
          if (!(vo && vo.length > 0)) {
            console.log('未筛选到有效场次，直接阻止不返回');
            return;
          }
          this.$fetch('exportChatSwitch', {
            room_id: this.roomId,
            switch_id: this.groupRound,
            start_time: vo[0].start_time,
            end_time: vo[0].end_time
          }).then(res => {
            // 暂无上报 this.$vhall_paas_port({
            //   k: 100457,
            //   data: {business_uid: this.userId, user_id: '', webinar_id: this.webinarId, refer: '', s: '', report_extra: {}, ref_url: '', req_url: ''}
            // })
            this.$vhMessage({
              message: this.$t('lang.k_189145', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
            this.groupRoundVisible = false;
          });
        } else {
          this.$vhMessage({
            message: `${this.$t('lang.k_189032')}`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
      },
      // 邀请详情导出
      exportInviteDetailInfo(id) {
        this.$fetch('exportDetailInvite', { webinar_id: this.webinarId, join_id: id }).then(res => {
          this.$vhall_paas_port({
            k: 100457,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 邀请导出
      //
      exportInviteInfo(export_fields) {
        if (Array.isArray(export_fields)) {
          export_fields = export_fields.join(',');
        }
        this.$fetch(
          'exportInvite',
          { source_id: +this.webinarId, source_type: 1, nickname: this.searchText, export_fields },
          { 'Content-Type': 'application/json' }
        ).then(res => {
          this.$vhall_paas_port({
            k: 100456,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 聊天
      exportChatInfo(type) {
        // keyword: this.searchText,
        let params = JSON.parse(JSON.stringify(this.params));
        if (type == 1) {
          if (!params.start_time && !params.keyword) {
            this.$vhMessage.warning(this.$t('lang.k_189147'));
            return false;
          }
        }
        if (type == 2) {
          delete params.start_time;
          delete params.end_time;
          delete params.keyword;
        }
        this.$fetch('exportChat', params)
          .then(res => {
            this.$vhall_paas_port({
              k: 100458,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.webinarId,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_189145', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          })
          .catch(err => {
            this.$vhMessage({
              message: err.msg,
              showClose: true,
              type: 'warning',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 问答
      exportRecordInfo() {
        this.$fetch('exportRecodrder', this.$params(this.params)).then(res => {
          this.$vhall_paas_port({
            k: 100461,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 签到
      exportSignInfo() {
        this.$fetch('exportSign', { room_id: this.roomId }).then(res => {
          this.$vhall_paas_port({
            k: 100465,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      exportDetailSignInfo(id) {
        this.$fetch('exportDetailSign', { room_id: this.roomId, sign_id: id }).then(res => {
          this.$vhall_paas_port({
            k: 100464,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      exportFileDetailDownloads(webinar_id, file_id) {
        this.$fetch('exportFileDetailDownloads', { webinar_id, file_id }).then(res => {
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 问卷
      exportQuestionInfo() {
        this.$fetch('exportSurvey', { webinar_id: this.webinarId, room_id: this.roomId }).then(
          res => {
            this.$vhall_paas_port({
              k: 100469,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.webinarId,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_189145', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          }
        );
      },
      // 快问快答导出
      exportExamInfo() {
        this.$fetch('exportExam', { webinar_id: this.webinarId, room_id: this.roomId }).then(
          res => {
            this.$vhMessage({
              message: this.$t('lang.k_189145', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          }
        );
      },
      // 文件下载导出
      exportFileDownloads() {
        const params = {
          webinar_id: this.webinarId,
          file_name: this.searchText
        };
        if (this.searchTime) {
          params.start_date = this.searchTime[0];
          params.end_date = this.searchTime[1];
        }
        this.$fetch('exportFileDownloads', params).then(res => {
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 抽奖
      exportPrizeInfo() {
        this.$fetch('exportLottery', this.params).then(res => {
          this.$vhall_paas_port({
            k: 100471,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 抽奖单个
      exportPrizeDetailInfo(item) {
        this.$fetch('exportDetailLottery', { webinar_id: this.webinarId, id: item.id }).then(
          res => {
            this.$vhall_paas_port({
              k: 100472,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.webinarId,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_189145', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          }
        );
      },
      // 现金红包
      exportRedpacketInfo() {
        this.$fetch('exportRedpacket', { webinar_id: this.webinarId }).then(res => {
          this.$vhall_paas_port({
            k: 100473,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 现金红包---导出明细
      exportRedpacketDetailInfo(uuid, type) {
        this.$fetch('exportDetailRedpacket', {
          webinar_id: this.webinarId,
          red_packet_uuid: uuid,
          type: type
        }).then(res => {
          this.$vhall_paas_port({
            k: 100474,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 口令红包--导出全部
      exportCodeRedpacketInfo() {
        this.$fetch('exportCodeRedpacket', { webinar_id: this.webinarId }).then(res => {
          if (res.code === 200) {
            this.$vhMessage({
              message: this.$t('lang.k_189145', [
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          } else {
            this.$vhMessage({
              message: res.msg,
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          }
        });
      },
      // 口令红包--导出明细详情（单个）
      exportCodeRedpacketDetailInfo(uuid, type) {
        this.$fetch('exportDetailCodeRedpacket', {
          webinar_id: this.webinarId,
          red_packet_uuid: uuid,
          type: type
        }).then(res => {
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 关注用户 - 导出全部（支持条件筛选）
      exportFollowersInfo() {
        let params = {
          webinar_id: this.webinar_id
        };
        if (this.searchTime) {
          params.start_time = this.searchTime[0] + ' 00:00:00';
          params.end_time = this.searchTime[1] + ' 23:59:59';
        }
        this.$fetch('exportFollowersInfo', params).then(res => {
          this.$vhall_paas_port({
            k: 100473,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.webinarId,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhMessage({
            message: this.$t('lang.k_189145', [
              this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_189144')
            ]),

            showClose: true,
            // duration: 0,
            type: 'success',
            customClass: 'zdy-info-box'
          });
          this.$EventBus.$emit('saas_vs_download_change');
        });
      },
      // 问卷查看
      lookDetail(that, val) {
        let rows = val.rows;
        that.$vhall_paas_port({
          k: 100470,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: this.webinarId,
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        that.$router.push({
          path: `${isEmbed() ? '/embed' : ''}${val.path}/${that.webinarId}`,
          query: {
            surveyId: rows.survey_id,
            roomId: embedRoomId() || that.$route.query.roomId,
            subject: rows.subject,
            number: rows.filled_number
          }
        });
      },
      // 快问快答查看
      lookExamDetail(that, val) {
        let rows = val.rows;
        that.$router.push({
          path: `${isEmbed() ? '/embed' : ''}${val.path}/${that.webinarId}`,
          query: { paperId: rows.paper_id, roomId: embedRoomId() || that.$route.query.roomId }
        });
      },
      // 查看邀请明细
      watchInfo(that, row) {
        that.$router.push({
          path: `${isEmbed() ? '/embed' : ''}/live/interactionDetail/invitedDataInfo`,
          query: {
            ...that.$route.query,
            invite_id: row.rows.invite_id,
            invite_id_type: row.rows.invite_id_type,
            nickname: row.rows.nickname_updated ? row.rows.nickname_updated : row.rows.nick_name
          }
        });
      },
      // 导出某一个人的邀请明细(该导出与邀请明细页面的 导出 一致)
      exportRowInviteDetail(that, scope) {
        that
          .$fetch(
            'exportInviteDetails',
            {
              invite_id: scope.rows.invite_id, // 邀请id
              invite_id_type: +scope.rows.invite_id_type, // 邀请id类型：1.C端用户id 2.游客id 3.B端用户
              // nick_name: '', // 被邀请人昵称
              // invite_type: '',
              // channel: '', // 渠道来源
              // begin_time: '', // 开始时间
              // end_time: '', // 结束时间
              source_id: +that.webinarId,
              source_type: 1
            },
            { 'Content-Type': 'application/json' }
          )
          .then(res => {
            that.$vhall_paas_port({
              k: 100456,
              data: {
                business_uid: that.userId,
                user_id: '',
                webinar_id: that.webinarId,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            that.$vhMessage({
              message: that.$t('lang.k_189145', [
                that.$store.state.permissionValue.custom_download_toast || that.$t('lang.k_189144')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            that.$EventBus.$emit('saas_vs_download_change');
          });
      }
    }
  };
</script>
<style lang="less" scoped>
  .title-data {
    height: 100%;
    span {
      font-size: 22px;

      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .interact-detail {
    .layout--right--main();
    .min-height();
    padding: 24px;
    .interact-invite-totel {
      line-height: 26px;
      font-size: 14px;
      color: #1a1a1a;
      margin-bottom: 24px;
      .color_26 {
        color: #fb2626;
        font-size: 18px;
      }
    }
  }

  .data-detail {
    .operaBox {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      position: relative;
      min-height: 36px;
      .searchBox {
        display: flex;
        &:first-child {
          margin-right: 20px;
        }
      }

      .vh-link {
        margin-left: 20px;
      }
      .searchBox {
      }
    }
    .search-export {
      position: absolute;
      top: 0;
      right: 0;
      .vh-input {
        width: 220px;
        .vh-input__icon {
          cursor: pointer;
        }
      }
    }
    .vh-form-item.no-border {
      margin-bottom: 0;
    }
  }
  .create_but_padding {
    margin-left: 10px;
  }
  .dropdown_width {
    .vh-dropdown-menu__item {
      white-space: normal;
    }
  }
</style>
<style lang="less">
  .vh-message-box--inviterank {
    width: 460px;

    .message-tip {
      color: #fb2626;
      line-height: 40px;
    }
    .vh-form-item__label {
      line-height: 30px;
    }

    .vh-checkbox {
      width: 110px;
      line-height: 1;
    }
  }
</style>
